import styled from 'styled-components';
import { getTheme } from 'settings/theme';

const { palette, boxShadow } = getTheme();
const TypeaheadWrapper = styled.div`
  width: 100%;
  height: 100%;

  .react-autosuggest__container {
    position: relative;
    width: 100%;

    input {
      border-radius: 0.4rem;
      border: 1px solid ${palette.greyscale.pewter};
      font-size: 1.6rem;
      height: 4.2rem;
      padding: 0 0 0 1.2rem;
      width: 100%;
      text-align: left;

      &:hover {
        border: 2px solid #c5c5c8;
        padding: 0 0 0 1.1rem;
      }
    }

    input.input-error {
      border-color: ${palette.red.default};
    }

    &--open {
      input {
        border: 1px solid ${palette.greyscale.black};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 0 none;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15), 0 3px 14px 2px rgba(0, 0, 0, 0.12),
          0 5px 5px -3px rgba(0, 0, 0, 0.2) !important;

        &:hover {
          border: 1px solid ${palette.greyscale.black};
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom: 0 none;
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15), 0 3px 14px 2px rgba(0, 0, 0, 0.12),
            0 5px 5px -3px rgba(0, 0, 0, 0.2) !important;
          padding: 0 0 0 1.2rem;
        }
      }

      .typeahead__autosuggest__container {
        display: block;
        overflow-y: scroll;
        height: 18rem;
        z-index: 1;
      }
    }
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: ${palette.greyscale.snow};
  }

  .typeahead {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &__autosuggest {
      &__container {
        display: none;
        background-color: ${palette.greyscale.white};
        border-bottom-left-radius: 0.6rem;
        border-bottom-right-radius: 0.6rem;
        border: 1px solid ${palette.greyscale.black};
        border-top: 0 none;
        box-shadow: ${boxShadow.default};
        padding: 0 0.8rem;
        position: absolute;
        width: 100%;
        top: 100%;

        ul {
          margin-top: 1rem;
          padding: 0;
          list-style-type: none;
        }

        &__separator {
          border: 1px solid ${palette.greyscale.pewter};
          display: inline-block;
          height: 0;
          left: 2.5%;
          position: absolute;
          width: 95%;
        }

        &__suggestion {
          padding: 0.1rem 0.7rem;
          border-radius: 0.4rem;
          vertical-align: middle;

          &:hover {
            background-color: ${palette.greyscale.snow};
          }

          span {
            width: 100%;
            text-align: left;
            font-size: 1.6rem;
            color: ${palette.greyscale.black};
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 500px) {
    .typeahead {
      .react-autosuggest__container {
        order: 1;
      }
    }

    .react-autosuggest__container {
      input {
        font-size: 3rem;
        height: 7rem;
      }
    }
  }
`;
export default TypeaheadWrapper;
